export const volumes = [
  { title: "La Réserve de Tablatures", desc: "Accédez instantanément à une bibliothèque de tablatures prêtes à l'emploi pour faire jouer vos élèves dès le premier cours." },
  { title: "Le Créateur de Mélodies pour Débutants", desc: "Des mélodies simples et entraînantes qui motivent les élèves et leur donnent envie de revenir." },
  { title: "Le Calendrier d'Exercices sur 30 Jours", desc: "Un plan quotidien pour progresser techniquement et installer de vraies habitudes de travail." },
  { title: "Le Pack d'Exercices Techniques", desc: "Des exercices ciblés pour des guitaristes plus solides et plus sûrs d'eux." },
  { title: "Les Fiches de Cours Prêtes à Enseigner", desc: "Des plans de cours complets : échauffement, notion, pratique, morceau et devoirs." },
  { title: "10 Partitions avec Exercices Prêts à l'Emploi", desc: "De beaux morceaux et des exercices pratiques pour commencer à enseigner dès aujourd'hui." },
];

export const bonuses = [
  { title: "Guide des Accords Essentiels", value: "19 $" },
  { title: "Cartes du Manche Imprimables", value: "15 $" },
  { title: "Kit de Suivi des Progrès de l'Élève", value: "17 $" },
  { title: "Certificats de Réussite à Imprimer", value: "12 $" },
  { title: "Playlist de Morceaux par Niveau", value: "14 $" },
  { title: "Modèles de Communication avec les Parents", value: "16 $" },
];

export const pains = [
  "Vous passez vos dimanches soir à préparer les cours de la semaine.",
  "Vous improvisez vos leçons et sentez que les élèves stagnent.",
  "Vous cherchez sans cesse des tablatures et des exercices adaptés au niveau de chacun.",
  "Vos élèves perdent leur motivation après quelques semaines.",
];

export const steps = [
  { title: "Imprimez", desc: "Choisissez la fiche du jour et imprimez-la en quelques secondes." },
  { title: "Enseignez", desc: "Suivez un déroulé clair, du premier échauffement jusqu'aux devoirs." },
  { title: "Répétez", desc: "Passez au cours suivant : le trimestre entier est déjà planifié." },
];

export const testimonials = [
  { name: "Claire M.", role: "Professeure de guitare, Lyon", quote: "J'ai récupéré mes week-ends. Je prépare maintenant un trimestre complet en une après-midi, et mes élèves adorent les mélodies." },
  { name: "Julien R.", role: "École de musique, Bordeaux", quote: "Le calendrier de 30 jours a changé la façon dont mes élèves travaillent chez eux. Les progrès sont visibles dès la deuxième semaine." },
  { name: "Sophie L.", role: "Cours particuliers, Montréal", quote: "Tout est clair, beau et prêt à imprimer. Je me sens enfin organisée et beaucoup plus professionnelle face aux parents." },
];

export const faqs = [
  { q: "Sous quel format vais-je recevoir le matériel ?", a: "Tous les volumes et bonus sont livrés en PDF haute qualité, prêts à imprimer ou à utiliser sur tablette." },
  { q: "Comment vais-je recevoir l'accès ?", a: "Immédiatement après votre paiement, vous recevez un e-mail avec votre lien de téléchargement." },
  { q: "Est-ce adapté aux élèves débutants ?", a: "Oui. Le contenu est pensé pour les débutants et les intermédiaires, enfants comme adultes." },
  { q: "Puis-je l'utiliser en cours collectifs ?", a: "Absolument. Vous pouvez imprimer autant de copies que nécessaire pour vos propres élèves." },
  { q: "Et si le produit ne me convient pas ?", a: "Vous bénéficiez d'une garantie satisfait ou remboursé de 7 jours. Un simple e-mail suffit." },
];
